import { render, staticRenderFns } from "./customerOccupationIdIssueDateUpdate.vue?vue&type=template&id=6b15bcc0&"
import script from "./customerOccupationIdIssueDateUpdate.vue?vue&type=script&lang=js&"
export * from "./customerOccupationIdIssueDateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports